// extracted by mini-css-extract-plugin
module.exports = {"relatedArticlesList":"post-aside_relatedArticlesList__iH_Mn","topicsList":"post-aside_topicsList__9YtB2","newsLetterCard":"post-aside_newsLetterCard__xQ5xh"};